export const AUDITOR_PRIVILEGES = /** @type {const} */ ({
  USE_OUTPUT: 'noteAuditor/useOutput',
  MANAGE_BEHAVIOR: 'noteAuditor/manageBehavior',
});

/**
 * @typedef {typeof AUDITOR_PRIVILEGES[keyof typeof AUDITOR_PRIVILEGES]} AuditorPrivilege
 */

/**
 * The single all-or-nothing flag the pair above replaces. Still written by the privileges settings
 * page, because frontends users have not updated yet read this key and nothing else. Nothing reads
 * it here: the 2026-09-15 migration carried the clinics that had revoked it onto the pair above.
 */
export const LEGACY_AUDITOR_PRIVILEGE = 'sessions/aiAuditAgent';
